import { useState } from "react";
import { format } from "date-fns";
import { CheckIcon1Svg } from "../../svgs/checkIcon1Svg";
import { RemoveIcon1Svg } from "../../svgs/removeIcon1Svg";
import { TrashIconSvg } from "../../svgs/trashIconSvg";
import { ConfirmModal } from "../../components/confirmModal";
import { toast } from "react-toastify";
import COUPONS from "../../api/services/COUPONS";
import CreateCouponModal from "../../components/CreateCouponModal";
import styles from "../../styles/_containers/_coupons/table.module.scss";
import { EditIconSvg } from "../../svgs/editIconSvg";
import EditCouponModal from "../../components/EditCouponModal";

const Table = ({ data, setResponseStatus }) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  // handle delete coupon
  const handleDeleteCoupon = async () => {
    try {
      setDeleteLoading(true);
      const res = await COUPONS.delete_coupon(isConfirmModalOpen);
      toast.success(res.data.message);
      setResponseStatus(true);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    } finally {
      setIsConfirmModalOpen(false);
      setDeleteLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>קופונים</h2>
        <button onClick={() => setIsCreateModalOpen(true)}>יצירת קופון חדש</button>
      </div>
      <div className={styles.tableWrapper}>
        <table>
          <thead>
            <tr>
              <th>שם</th>
              <th>סוג הנחה</th>
              <th>מחיר</th>
              <th>תוקף</th>
              <th>כמות</th>
              <th>כמות מימושים</th>
              <th>לקוח יכול לממש יותר מפעם אחת</th>
              <th>סטטוס</th>
              <th>סטטוס</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 && (
              <tr>
                <td colSpan={10}>
                  <p>נראה שאין לך קופונים</p>
                </td>
              </tr>
            )}
            {data.map((i) => (
              <tr key={i._id}>
                <td>{i.name}</td>
                <td>{i.priceType}</td>
                <td>
                  {i.priceType === "percentage" ? `%${i.price}` : `${i.price}₪`}
                </td>
                <td>{format(new Date(i.expiryDate), "dd/MM/yyyy")}</td>
                <td>{i.quantity ? i.quantity : "Unlimited"}</td>
                <td>{i.noOfUsage}</td>
                <td>
                  {i.allowMultipleUsesPerUser ? (
                    <CheckIcon1Svg fill="green" />
                  ) : (
                    <RemoveIcon1Svg fill="red" />
                  )}
                </td>
                <td>
                  <button
                    className={`${!i.isActive ? styles.red : styles.green}`}
                  >
                    {i.isActive ? "פעיל" : "לא פעיל"}
                  </button>
                </td>
                <td>
                  <button
                    className={`${i.expired ? styles.red : styles.green}`}
                  >
                    {i.expired ? "פג תוקף" : "בתוקף"}
                  </button>
                </td>
                <td>
                  <div className={styles.icons}>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsEditModalOpen(i._id)}
                    >
                      <EditIconSvg fill="blue" />
                    </div>
                    &nbsp; &nbsp;
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsConfirmModalOpen(i._id)}
                    >
                      <TrashIconSvg fill="red" />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* DELETE MODAL */}
      {isConfirmModalOpen && (
        <ConfirmModal
          setIsOpen={setIsConfirmModalOpen}
          handleClick={handleDeleteCoupon}
          loading={deleteLoading}
        />
      )}

      {/* CREATE MODAL */}
      {isCreateModalOpen && (
        <CreateCouponModal
          setIsOpen={setIsCreateModalOpen}
          setResponseStatus={setResponseStatus}
        />
      )}

      {/* EDIT MODAL */}
      {isEditModalOpen && (
        <EditCouponModal
          setIsOpen={setIsEditModalOpen}
          couponId={isEditModalOpen}
          setResponseStatus={setResponseStatus}
        />
      )}
    </div>
  );
};

export default Table;
